import Button, {BtnColor} from "../../../components/Button/Button";
import PulseLoader from "react-spinners/PulseLoader";
import {Dialog, RadioGroup, Transition} from "@headlessui/react";
import {Fragment, useState} from "react";
import {useTranslation} from "react-i18next";
import {
    onIikoTransportOrganizationsLoad, onIikoTransportOrganizationsShowModal,
    onIikoTransportSetOrganization,
} from "../../../store/Restaurant/actions";
import {useDispatch, useSelector} from "react-redux";
import CheckIcon from "./CheckIcon";


const IikoTransportOrganization = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [organizationLocal, setOrganizationLocal] = useState({})

    const {loading, restaurant_id, integration_id, showModal, organizations, api_login, organization_id } = useSelector(state => ({
        restaurant_id: state.restaurant.restaurant_id,
        loading: state.restaurant.iiko_transport.organizations.loading,
        showModal: state.restaurant.iiko_transport.organizations.show_modal,
        organizations: state.restaurant.iiko_transport.common.organizations,

        integration_id: state.restaurant.pos_selected?.integration?.id,

        api_login: state.restaurant.iiko_transport.selected.api_login,
        organization_id: state.restaurant.iiko_transport.selected.organization_id,
        terminal_group_id: state.restaurant.iiko_transport.selected.terminal_group_id,
        payment_id: state.restaurant.iiko_transport.selected.payment_id,
    }));

    const closeModal = () => {
        dispatch(onIikoTransportOrganizationsShowModal(false))
    }

    const setOrganization = (item) => {
        let params = {
            restaurant_id,
            integration_id,
            organization: item,
        }
        setOrganizationLocal(item)
        dispatch(onIikoTransportSetOrganization(params))
    }

    const loadInfo = () => dispatch(onIikoTransportOrganizationsLoad(restaurant_id, api_login))

    return (
        <>
                <>
                    <div className="col-span-1 col-start-1">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Organization id</label>
                        <input type="text"
                               value={organization_id}
                               readOnly={true}
                               disabled={true}
                               className="disabled:opacity-50 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <div className="py-3 relative">
                        <Button color={BtnColor.indigo}
                                className={"absolute bottom-0"}
                                type={"button"}
                                onClick={loadInfo}>
                            {loading ? (
                                <PulseLoader color="rgba(255, 255, 255, 1)" loading={loading}  size={5} />
                            ) : t(organization_id ? 'Update organization id' : 'Load organizations') }
                        </Button>
                    </div>

                </>


            <Transition appear show={showModal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl  p-6 text-left align-middle shadow-xl transition-all bg-gray-50">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        iikoTransport organizations
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            Please select organization id

                                            <RadioGroup value={organizationLocal} onChange={setOrganization}>
                                                <RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
                                                <div className="space-y-2">
                                                    {organizations.map((organization) => (
                                                        <RadioGroup.Option
                                                            key={organization.name}
                                                            value={organization}
                                                            className={({ active, checked }) =>
                                                                `${
                                                                    active
                                                                        ? 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-sky-300'
                                                                        : ''
                                                                }
                  ${
                                                                    checked ? 'bg-blue-900 bg-opacity-75 text-white' : 'bg-white'
                                                                }
                    relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none`
                                                            }
                                                        >
                                                            {({  checked }) => (
                                                                <>
                                                                    <div className="flex w-full items-center justify-between">
                                                                        <div className="flex items-center">
                                                                            <div className="text-sm">
                                                                                <RadioGroup.Label
                                                                                    as="p"
                                                                                    className={`font-medium  ${
                                                                                        checked ? 'text-white' : 'text-gray-900'
                                                                                    }`}
                                                                                >
                                                                                    {organization.name}
                                                                                </RadioGroup.Label>
                                                                                <RadioGroup.Description
                                                                                    as="span"
                                                                                    className={`inline ${
                                                                                        checked ? 'text-sky-100' : 'text-gray-500'
                                                                                    }`}
                                                                                >
                                                                                    <span>{organization.id}</span>
                                                                                </RadioGroup.Description>
                                                                            </div>
                                                                        </div>
                                                                        {checked && (
                                                                            <div className="shrink-0 text-white">
                                                                                <CheckIcon className="h-6 w-6" />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </RadioGroup.Option>
                                                    ))}
                                                </div>
                                            </RadioGroup>

                                        </p>
                                    </div>

                                    <div className="mt-4">
                                        <button
                                            type="button"
                                            className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                            onClick={closeModal}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export default IikoTransportOrganization;
